import { useState } from 'react';

import { useLocation, useNavigate } from 'js/lib/useRouter';

import { isInFilterTestVariant } from 'bundles/search-common/utils/experimentUtils';
import useIsConsumerSerp from 'bundles/search-common/utils/useIsConsumerSerp';
import { RedirectError } from 'bundles/ssr/lib/errors/directives';
import inServerContext from 'bundles/ssr/util/inServerContext';

import _t from 'i18n!nls/search';

const useDefaultLanguageFilter = () => {
  const isConsumerSearchPage = useIsConsumerSerp();
  const navigate = useNavigate();
  const {
    pathname,
    query: { language },
    search: searchString,
  } = useLocation();

  const [hasLanguage, setHasLanguage] = useState(
    typeof language === 'string' || (Array.isArray(language) && language.length > 0)
  );

  const inFilterTestVariantAndOnSearch = isInFilterTestVariant() && isConsumerSearchPage;
  // This actually errors out in Snowpack if I try to import this as a named param!
  // eslint-disable-next-line import/no-named-as-default-member
  const localeIsEnglish = _t.getLocale() === 'en';

  if (!hasLanguage && inFilterTestVariantAndOnSearch && localeIsEnglish) {
    const paramsToManipulate = new URLSearchParams(searchString);
    paramsToManipulate.append('language', 'English');

    const redirectUri = `${pathname}?${paramsToManipulate.toString()}`;
    const navigateObject = { pathname, search: `?${paramsToManipulate.toString()}` };

    // Redirect logic copied over from `static/bundles/help-redirects/utils/redirection.ts`
    if (inServerContext) {
      throw new RedirectError(302, redirectUri);
    } else {
      navigate(navigateObject, { replace: true });
    }
    setHasLanguage(true);
  }
};

export default useDefaultLanguageFilter;
